export const toDateString = (date) => {
  if (date == null) return "";
  date = new Date(date);
  let regDate = "" + date.getFullYear();
  regDate = `${pad(date.getDay() + 1, 2)}.${pad(
    date.getMonth() + 1,
    2
  )}.${regDate}`;

  return regDate;
};

const pad = (str, len) => {
  if (typeof str != "string") str = "" + str;
  while (str.length < len) str = "0" + str;
  return str;
};

const aircraftCategoryMap = {
  Aircraft: "Fly",
  Helicopter: "Helikopter",
  Glider: "Seilfly",
  "Power Glider": "Seilfly",
  "Balloon (hot-air)": "Ballong",
  "Balloon (gas)": "Ballong",
};

export const aircraftCategoryTranslated = (str) => {
  return aircraftCategoryMap[str] ? aircraftCategoryMap[str] : str;
};
